'use client';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import dynamic from 'next/dynamic';
import { findCols, findRows } from './functions';
import { Overlay } from './styles';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

const Markdown = dynamic(() => import('@repo/ui/src/components/Markdown'));
const PhotoGallery = ({ title, markdownDescription, body, _testID }) => {
  const { push } = useModal(ModalID.image);
  const smAndDown = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const photoQty = body.length;

  return (
    <div
      className="tw-flex tw-justify-center tw-px-4 md:tw-px-8 tw-py-8 md:tw-py-16 rotating-background"
      tabIndex={1}
      data-test-id={`photo_gallery_${_testID}`}
    >
      <Container>
        {title && (
          <Typography variant="h4" component="h2" align="center" gutterBottom>
            {title}
          </Typography>
        )}
        {markdownDescription && (
          <Markdown className="tw-text-center tw-mb-6" bodySize="xLarge">
            {markdownDescription}
          </Markdown>
        )}
        <ImageList
          cols={
            photoQty === 1
              ? 1
              : smAndDown
                ? 2
                : photoQty === 9
                  ? 6
                  : photoQty === 8
                    ? 15
                    : photoQty === 7
                      ? 12
                      : photoQty
          }
          sx={{ margin: '0 auto', maxWidth: { xs: '370px', md: 'none' } }}
        >
          {body.map((tile, i) => {
            const imgUrl = tile?.image && buildImageSrc(tile.image[0], 470, 1, 1);
            const instagramHandle = tile?.instagramHandle;
            const image = tile?.image[0];
            const imgLink = tile.imgLink;
            const recommendedProduct = tile.recommendedProduct;
            return (
              <ImageListItem
                key={i}
                cols={findCols(photoQty, i, smAndDown)}
                rows={findRows(photoQty, i, smAndDown)}
                sx={{ maxWidth: 470, margin: '0 auto' }}
              >
                <button
                  onClick={() => push({ instagramHandle, image, imgLink, recommendedProduct })}
                  className="tw-group focus:tw-outline-action-400 focus:tw-border-2"
                >
                  <LazyLoadImage
                    imgComponent={
                      <img
                        src={imgUrl}
                        alt={
                          tile.image && tile.image.length && tile.image[0].name
                            ? tile.image[0].name
                            : instagramHandle || 'carousel-image'
                        }
                        className="tw-w-full tw-cursor-pointer"
                      />
                    }
                    className="tw-h-full"
                  />
                  <Overlay className="overlay tw-items-center tw-justify-center tw-hidden group-hover:tw-flex group-focus:tw-flex">
                    <span>
                      {tile?.instagramHandle && (
                        <p className="tra-text-web-body-l tw-text-center">{tile.instagramHandle}</p>
                      )}
                      <p className="tra-text-web-body-l tw-text-center">View</p>
                    </span>
                  </Overlay>
                </button>
              </ImageListItem>
            );
          })}
        </ImageList>
      </Container>
    </div>
  );
};

export default PhotoGallery;
